export default __webpack_public_path__ + "static/media/youtube.73ea346b.svg";